export const FILTERS = {
  OPERATIONS: {
    EQ: 'eq',
    NE: 'ne',
    GT: 'gt',
    GTE: 'gte',
    LT: 'lt',
    LTE: 'lte',
    BETWEEN: 'between',
    IN: 'in',
    INCLUDES: 'includes',
  },
};

export enum AllowedOperators {
  EQ = 'eq',
  NE = 'ne',
  GT = 'gt',
  GTE = 'gte',
  LT = 'lt',
  LTE = 'lte',
  BETWEEN = 'between',
  IN = 'in',
  INCLUDES = 'includes',
}

export enum SortOrder {
  ASC = 'asc',
  DESC = 'desc',
}

export type FilterCondition = {
  op: AllowedOperators;
  val: string | number | boolean | (string | number | boolean)[];
};

export type Filter = {
  field: string;
  label?: string;
  conditions: FilterCondition[];
};

export type FilterPayload = Filter[];

export function isFilter(val: any): val is Filter {
  return val && typeof val === 'object' && 'field' in val && 'conditions' in val;
}
